import { isDev } from "./misc";

export const debug = (...args) => isDev() && console.debug(`GS:`, ...args);
